module.exports = __webpack_public_path__ + "img/hands-bubbles.f9a8b3cf.svg";